import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils";

type Props = {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}

const bem = new BemHelper("floating-menu-option");

export const FloatingMenuOption: React.FC<Props> = ({ icon, label, onClick }) => {
  return (
    <div className={classNames(bem.block())} onClick={() => onClick && onClick()}>
      {icon}
      <label className={classNames(bem.element('label'))}>{label}</label>
    </div>
  )
}
